import type { FC } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import PersonalizeAcrossSitesAppsChannelsImage from './PersonalizeAcrossSitesAppsChannelsImage'

const copy = {
  heading: `Personalize across sites, apps, and channels`,
}

const list = [
  {
    title: `Understand your ideal customers`,
    description: `Create a complete and consistent customer profile that each team can use to personalize real-time experiences and respect user preferences.`,
  },
  {
    title: `Improve conversion rates`,
    description: `Build personalized experiences by adapting your apps and websites to showcase specific products, categories, or content depending on your customers’ recent interactions.`,
  },
]

const PersonalizeAcrossSitesAppsChannels: FC = () => {
  return (
    <SectionBase variant="2Col">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <StyledColumnTrack>
            {list.map(({ title, description }, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{title}</FeatureBox.Title>
                  <FeatureBox.Text>{description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </StyledColumnTrack>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <Contents>
          <ImageWrapper
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1,
              },
            }}
            viewport={{ once: true }}
          >
            <PersonalizeAcrossSitesAppsChannelsImage />
          </ImageWrapper>
        </Contents>
      </Section.Contents>
    </SectionBase>
  )
}

export default PersonalizeAcrossSitesAppsChannels

const Contents = styled.div`
  position: relative;
  height: 100%;
`

const StyledColumnTrack = styled(ColumnTrack)`
  padding-top: 24px;
`

const ImageWrapper = styled(m.div)``
